import {  Link } from "react-router-dom"
import SVTopNavitem from "./SVTopNavitem"
import {StaticRouter} from 'react-router'



import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';

//import {LoginabodeContainerCom} from '../../containers'

const React = require('react')
const {noop} = StaticRouter
export  class SVTopNav extends React.Component{
    pufancy(fancy){
        console.log('update State fro SVTopNavItem')
        let f ={
            pufancy :false,
            puto : '/bus'
        }
        f = fancy
        this.setState ({fancy:f})
        

    }
    constructor(props){
        super(props)
        let me = this
        this.state = {
            fancy: {
                pufancy :false,
                puto : '/bus'
            }
           
        }
        this.pufancy = this.pufancy.bind(me)
        this.navClick = this.navClick.bind(this)
        this.state={
            svClassValue:{
               0 :'active',
               1:'',
               2:'',
               3:'',
               4:''
            }
        }

    }

navClick(event){
    console.log('nav click')
    console.log(event.target.value)
}
    render(){
        const {pufancy} = this
        //const {nob} = this.props
        return (
        <div className="col-xs-6" style={{"display":"black"}}>
            
            <ul id="subNavDiv" className="hopper-nav list-horizontal pull-right">
                <li><strong>Open Stack</strong>
                </li>
                
                <SVTopNavitem pufancy={this.pufancy} to="/inetcosmos/svflysearch"> COSMOS(SVFlights) </SVTopNavitem>
  
                <SVTopNavitem pufancy={this.pufancy} to="/inetabode/svessearch"> Sojourns </SVTopNavitem>
                <SVTopNavitem pufancy={this.pufancy} to="/svlogin"> SVMy Reservations </SVTopNavitem>
  
                <SVTopNavitem pufancy={this.pufancy}  to="/sandwiches"> SandwichesHeader </SVTopNavitem>
               
  
            
            </ul>
        </div>
        )
    }
}